import { Input } from '@/common-utils/components/ui/input';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import FilterButtons from '../buttons/FilterButtons';
import Entity from '../../../entity/Entity';

/**
 *
 * @param root0
 * @param root0.addFilter
 * @param root0.columnId
 * @param root0.defaultValue
 * @param root0.resetThisFilter
 * @param root0.entity
 * @param root0.namespace
 * @param root0.setLaunchSearch
 * @returns {JSX} InputFilter
 */
function InputFilter({
    addFilter,
    columnId,
    defaultValue,
    resetThisFilter,
    entity,
    namespace,
    setLaunchSearch
}) {

    const [value, setValue] = useState(defaultValue ?? '');
    const [isDirty, setIsDirty] = useState(false);
    const [placeholderWidth, setPlaceholderWidth] = useState(0);

    // Hooks
    useEffect(() => {
        if (resetThisFilter && isDirty) {
            setValue('');
            setIsDirty(false);
        }
    }, [resetThisFilter]);

    useEffect(() => {
        if (document.getElementById('input-filter-placeholder')) {
            // 26px = 24px (padding-left/right) + 2px (border-width-left/right) of the input element
            setPlaceholderWidth(document.getElementById('input-filter-placeholder').offsetWidth + 26);
        }
    }, [columnId]);

    return (
        <div className='flex gap-2'>
            <Entity id='input-filter-placeholder' entity={entity} namespace={namespace} className='text-sm absolute opacity-0 pointer-events-none' />
            <Input
                id='input-filter'
                namespace={namespace}
                entity={entity}
                value={value}
                onChange={(event) => {
                    setIsDirty(true);
                    setValue(event?.target?.value);
                }}
                onKeyDown={(event) => {
                    if (event.key === 13 || event.which === 13 || event.keyCode === 13) {
                        addFilter(columnId, value);
                        setLaunchSearch(true);
                    }
                }}
                autoFocus={true}
                placeholderWidth={placeholderWidth}
                className='min-w-40 h-9'
                data-cy='input-filter'
            />
            <FilterButtons
                addFilter={addFilter}
                columnId={columnId}
                filterValue={value}
                setLaunchSearch={setLaunchSearch}
                disableSearchButton={!isDirty}
            />
        </div>
    );
}
InputFilter.propTypes = {
    addFilter: PropTypes.func,
    columnId: PropTypes.string,
    defaultValue: PropTypes.any,
    resetThisFilter: PropTypes.bool,
    entity: PropTypes.string,
    namespace: PropTypes.string,
    setLaunchSearch: PropTypes.func
};


export default InputFilter;